import {StringUtils} from '@vdw/angular-component-library';

export class VersionHistory {
  private _dateModified: Date;
  private _version: number;
  private _changes: string;
  private _readyForProduction: boolean;
  private _additionalInformation: string;
  private _weaveStructureName: string;
  private _weaveStructureVersion: number;
  private _qualityName: string;
  private _qualityVersion: number;

  public constructor(
    dateModified: Date,
    version: number,
    changes: string,
    readyForProduction: boolean,
    additionalInformation: string,
    weaveStructureName: string,
    weaveStructureVersion: number,
    qualityName: string,
    qualityVersion: number
  ) {
    this._dateModified = dateModified;
    this._version = version;
    this._changes = changes;
    this._readyForProduction = readyForProduction;
    this._additionalInformation = additionalInformation;
    this._weaveStructureName = weaveStructureName;
    this._weaveStructureVersion = weaveStructureVersion;
    this._qualityName = qualityName;
    this._qualityVersion = qualityVersion;
  }

  public get dateModified(): Date {
    return this._dateModified;
  }

  public set dateModified(dateModified: Date) {
    this._dateModified = dateModified;
  }

  public get version(): number {
    return this._version;
  }

  public set version(version: number) {
    this._version = version;
  }

  public get changes(): string {
    return this._changes;
  }

  public set changes(changes: string) {
    this._changes = changes;
  }

  public get readyForProduction(): boolean {
    return this._readyForProduction;
  }

  public set readyForProduction(readyForProduction: boolean) {
    this._readyForProduction = readyForProduction;
  }

  public get additionalInformation(): string {
    return this._additionalInformation;
  }

  public set additionalInformation(additionalInformation: string) {
    this._additionalInformation = additionalInformation;
  }

  public get weaveStructureName(): string {
    return this._weaveStructureName;
  }

  public set weaveStructureName(weaveStructureName: string) {
    this._weaveStructureName = weaveStructureName;
  }

  public get weaveStructureVersion(): number {
    return this._weaveStructureVersion;
  }

  public set weaveStructureVersion(weaveStructureVersion: number) {
    this._weaveStructureVersion = weaveStructureVersion;
  }

  public get qualityName(): string {
    return this._qualityName;
  }

  public set qualityName(qualityName: string) {
    this._qualityName = qualityName;
  }

  public get qualityVersion(): number {
    return this._qualityVersion;
  }

  public set qualityVersion(qualityVersion: number) {
    this._qualityVersion = qualityVersion;
  }

  public static fromJSON(versionHistoryJSON: any): VersionHistory {
    return new VersionHistory(
      StringUtils.toDate(versionHistoryJSON.dateModified),
      versionHistoryJSON.version,
      versionHistoryJSON.changes,
      versionHistoryJSON.readyForProduction,
      versionHistoryJSON.additionalInformation,
      versionHistoryJSON.weaveStructureName,
      versionHistoryJSON.weaveStructureVersion,
      versionHistoryJSON.qualityName,
      versionHistoryJSON.qualityVersion
    );
  }
}
